import { Fragment, Slice } from '@atlaskit/editor-prosemirror/model';
import { TextSelection } from '@atlaskit/editor-prosemirror/state';
import { findTable } from './find';
import { isTableSelected } from './is-selected';
export var replaceSelectedTable = function replaceSelectedTable(state, content) {
  if (isTableSelected(state.selection)) {
    var table = findTable(state.selection);
    if (table) {
      var slice = typeof content === 'string' ? new Slice(Fragment.from(state.schema.text(content)), 0, 0) : content;
      var tr = state.tr.replace(table.pos, table.pos + table.node.nodeSize, slice);
      tr.setSelection(TextSelection.create(tr.doc, table.pos + slice.size + 1));
      return tr;
    }
  }
  return state.tr;
};